import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ImageWithFallback from './ImageWithFallback';
import './Footer.css';

const countries = [
  { name: 'Russia', code: 'RU' },
  { name: 'Australia', code: 'AU' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Dubai', code: 'AE' },
  { name: 'USA', code: 'US' },
  { name: 'Canada', code: 'CA' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Portugal', code: 'PT' },
  { name: 'India', code: 'IN' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleWorkClick = (e) => {
    e.preventDefault();
    const element = document.getElementById('work');
    if (element) {
      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
    } else {
      window.location.href = '/#work';
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/">
              <ImageWithFallback 
                src="/assets/img/logo.png" 
                alt="Team FullStack" 
                className="footer-logo"
                priority={true}
                fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='50'%3E%3Ctext x='10' y='35' font-family='Arial' font-size='24' font-weight='bold' fill='white'%3ETeam FullStack%3C/text%3E%3C/svg%3E"
              />
            </Link>
            
            <p className="footer-tagline">
              Where Growing Begins...
            </p>
            
            <div className="footer-presence">
              <div className="footer-flags">
                {countries.map((country, index) => (
                  <span 
                    key={index} 
                    className={`flag-item ${country.name === 'India' ? 'headquartered' : ''}`}
                    title={country.name === 'India' ? `${country.name} (Headquartered)` : country.name}
                  >
                    <img 
                      src={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png`}
                      alt={country.name}
                      className="flag-icon"
                      loading="lazy"
                    />
                    {country.name === 'India' && <span className="flag-label">HQ</span>}
                  </span>
                ))}
              </div>
            </div>
            
            <div className="footer-contact-info">
              <p className="contact-text">
                <strong>Registered Address:</strong><br />
                3/403 Chhaya Bldg, Vasant Leela, B/h Vijay Nagari Annex, Waghbil, GN Road, Thane (West) 400615
              </p>
              
              <p className="contact-text">
                <strong>Head Office:</strong><br />
                Unit G22, Kohinoor City Mall, Kohinoor City, Kurla (West) 400070 Mumbai
              </p>
              
              <p className="contact-text">
                <strong>Phone:</strong> <a href="tel:+917668628401">+91 76686 28401</a> / <a href="tel:+919619118118">+91 9619118118</a>
              </p>
              
              <p className="contact-text">
                <strong>Email:</strong> <a href="mailto:parth@teamfullstack.in">parth@teamfullstack.in</a>
              </p>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h3>Company</h3>
              <Link to="/about">About Us</Link>
              <Link to="/services">Services</Link>
              <a href="#work" onClick={handleWorkClick}>Work</a>
              <Link to="/news">News</Link>
              <Link to="/contact">Contact</Link>
            </div>

            <div className="footer-column">
              <h3>Solutions</h3>
              <Link to="/services/brand-solutions">Brand Solutions</Link>
              <Link to="/services/tech-solutions">Tech Solutions</Link>
              <Link to="/services/media-solutions">Media Solutions</Link>
              <Link to="/services/research-solutions">Research Solutions</Link>
              <Link to="/services/web-development">Web Development</Link>
              <Link to="/services/generative-ai">Generative AI</Link>
              <Link to="/services/delegation-management">Delegation Management</Link>
              <Link to="/services/product-shoots">Product Shoots</Link>
            </div>

            <div className="footer-column">
              <h3>Connect</h3>
              <a
                href="https://www.linkedin.com/company/team-fullstack/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              <a href="mailto:info@teamfullstack.com">Email</a>
              <a href="tel:+919876543210">Phone</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Team FullStack. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/terms-and-conditions">Terms & Conditions</Link>
            <span>•</span>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
